export default __webpack_public_path__ + "static/media/image.rn-innovations.21b7dd74.png";